import React, { useEffect, useState } from "react"
import { useAuthActions } from "../firebase/useAuth"
import { auth } from "../firebase/firebase"
import { TextInput } from "../helpers/components"
import { handleSwitchState, handleTextInputChange } from "../helpers/functions"
import { useHistory } from "react-router-dom"

export default function LoginForm() {
  const history = useHistory()

  const [showSignIn, setShowSignIn] = useState(false)
  const [error, setError] = useState(null)

	const [displayName, setDisplayName] = useState("")
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
  const [repeatedPassword, setRepeatedPassword] = useState("")

  const { login, register } = useAuthActions({ email, password, displayName })

  useEffect(() => { setTimeout(() => setError(null), 4000) }, [error])

	const onLogin = e => {
    e.preventDefault()
    login()
      .then(() => history.push("/"))
      .catch(err => setError(err.message))
  }

  const onRegister = async e => {
    e.preventDefault()
    if(displayName.length < 3) return setError("Votre nom doit contenir au moins 3 caractères")
    if(password !== repeatedPassword) return setError("Les mots de passes ne match pas")
    register().catch(err => setError(err.message))
  }

	return (
		<div className="login">
      <div className="row">
        <div className="col">
          <div className="textBox">
            <h1 className="title">Une organisation pour plus de résultats</h1>
            <p className="smallText">Lorem ipsum dolor sit amet consectetur adipisicing elit. A, laudantium quia quidem et at voluptate quo voluptas quae tempora odit aut corrupti repudiandae velit alias atque, reprehenderit exercitationem reiciendis ex! Necessitatibus aliquid pariatur maiores eum quam repellendus officiis ea fugiat sed consequatur vitae, tempore quisquam, praesentium soluta, at assumenda repudiandae!</p>
          </div>
        </div>
        <div className="col">
          <div className="loginBox">
            <h2 style={{ marginBottom: "2rem" }}>
              Keep It Organized - {showSignIn ? "Inscription" : "Connexion"}
            </h2>
            <form className="loginForm" onSubmit={showSignIn ? onRegister : onLogin}>
              {showSignIn && (
                <TextInput
                  value={displayName}
                  onChange={handleTextInputChange(setDisplayName)}
                  className="nameInput loginForm__input"
                  label="Nom d'utilisateur"
                />
              )}
              <TextInput
                value={email}
                onChange={handleTextInputChange(setEmail)}
                className="emailInput loginForm__input"
                label="Email"
                type="email"
              />
              <TextInput
                value={password}
                onChange={handleTextInputChange(setPassword)}
                className="passwordInput loginForm__input"
                label="Mot de passe"
                type="password"
              />
              {showSignIn && (
                <TextInput
                  value={repeatedPassword}
                  onChange={handleTextInputChange(setRepeatedPassword)}
                  className="repeatPasswordInput loginForm__input"
                  label="Répétez le mot de passe"
                  type="password"
                />
              )}
              {error && <div className="error">{error}</div> }
              <button className="submitBtn" type="submit">
                {showSignIn ? "S'inscrire" : "Se connecter"}
              </button>
              {!showSignIn ? (
                <div className="switchLoginForm">
                  Vous n'avez pas de compte ? <span className="link" onClick={() => handleSwitchState(setShowSignIn)}>
                    Inscrivez vous ici
                  </span>
                </div>
              ) : (
                <div className="switchLoginForm">
                  Déjà un compte ? <span className="link" onClick={() => handleSwitchState(setShowSignIn)}>
                    Connectez vous ici
                  </span>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
		</div>
	)
}
